import axios from '@/libs/api.request';

export const getUserList = data => {
    return axios.request({
        url: 'api/systemManagement/userManagement/getUserList',
        data: data,
        method: 'post'
    });
};

export const registerFddAccountForUser = data => {
    return axios.request({
        url: 'api/esignature/registerFddAccountForUser',
        data: data,
        method: 'post'
    });
};


export const SignContractForUser = data => {
    return axios.request({
        url: 'api/esignature/SignContractForUser',
        data: data,
        method: 'post'
    });
};
export const getDefaultSeedFarmUuid = data => { 
    return axios.request({
        url: 'api/systemManagement/userManagement/getDefaultSeedFarmUuid',
        data: data,
        method: 'post'
    });
};
